import { useState, useEffect } from "react";
import QuickFilter from "../../Common/QuickFilter";

const CustomerQuickFilter = (props) => {
  const [maxEquipSizes, setMaxEquipSizes] = useState([]);
  const [overrideRoutes, setOverrideRoutes] = useState([]);

  useEffect(() => {
    props.glEventHub.on("updatedCustomerData", updateCustomerData);
    return () => {
      props.glEventHub.off("updatedCustomerData", updateCustomerData);
    };
  }, [props.glEventHub]);

  const updateCustomerData = ({ maxEquipSizes, overrideRoutes }) => {
    setMaxEquipSizes(getOptionsData(maxEquipSizes));
    setOverrideRoutes(getOptionsData(overrideRoutes));
  };

  const getOptionsData = (optionData) => {
    return optionData.map((value) => ({ label: value, value: value }));
  };

  return (
    <QuickFilter
      key={props.filterName}
      customStore={{
        CustomerStore: {
          maxEquipSizes,
          overrideRoutes,
        },
      }}
      {...props}
    />
  );
};

export default CustomerQuickFilter;
